import { useMemo } from 'react';
import useThunkDispatch from 'packages/hooks/useThunkDispatch';
import { setSaveStatus } from 'packages/store/creativeEditor/creativeEditor.actions';
import useAccessRights from 'packages/hooks/useAccessRights';
import useEditor from 'packages/hooks/useEditor';
import { EXPORT_TYPE_OPTIONS } from './enums';

export const useExportSettings = () => {
    const dispatch = useThunkDispatch();
    const { isPlatformAllowed } = useAccessRights();
    const { exportIntegrations, toggleExportIntegration, changeExportValue } = useEditor();

    const handleIntegrationChange = (name) => () => {
        toggleExportIntegration(name);
        dispatch(setSaveStatus(false));
    };

    const handleExportTypeClick = (name) => {
        changeExportValue(name);
        dispatch(setSaveStatus(false));
    };

    const bothExportChosen =
        isPlatformAllowed(['bynder_waiting_room_upload']) &&
        exportIntegrations.BYNDER?.enabled &&
        exportIntegrations.DOWNLOAD?.enabled;
    const isWaitingChosen = exportIntegrations.BYNDER?.enabled;
    const isDownloadChosen = exportIntegrations.DOWNLOAD?.enabled || !isPlatformAllowed(['bynder_waiting_room_upload']);

    const chosenExportValue = useMemo(() => {
        if (!bothExportChosen && !isDownloadChosen && !isWaitingChosen) {
            return EXPORT_TYPE_OPTIONS[0];
        }

        if (bothExportChosen) {
            return EXPORT_TYPE_OPTIONS[0];
        } else if (isDownloadChosen) {
            return EXPORT_TYPE_OPTIONS[1];
        }

        return EXPORT_TYPE_OPTIONS[2];
    }, [exportIntegrations]);

    return {
        handleIntegrationChange,
        handleExportTypeClick,
        chosenExportValue,
        exportIntegrations,
    };
};
